<template>
  <div ref="pageCon">
        <div class="yearShowPage" v-html="content" >
            
        </div>
        <div class="footerCon">
			<div style="padding-top: 5px;padding-bottom: 5px;margin-right: 24px;"><a href='https://218.26.86.27:8067/ei/Ei!certificate.action?id=9028ffb17604406e01761864b3aa0010' target='_blank' style='border:0;height: 36px;'><img src='../../assets/image/shichang.png' style='border:0;height: 100%;width: 100%;'/></a></div>
                <div class="address"><img src="../../assets/image/address.png" alt=""><div>{{$t('language.address_b')}}：山西省/晋中市/平遥县/顺城路/故宫文创</div></div>
                <div class="email"><img src="../../assets/image/email.png" alt=""><div>{{$t('language.emails')}}：{{info.email}}</div></div>
       </div>
       <Fixed :goTop="gotoT"></Fixed>
  </div>
</template>
<script>
import Fixed from '../../components/fixed.vue';
export default {
    name:'yearShow',
    data(){
        return{
           content:'',
           info:{}
        }
    },
    components:{
       Fixed
    },
    mounted(){
        // 侧边菜单显示
        let fixCon = document.getElementsByClassName("fixed")[0]; 
        fixCon.style.opacity = "1";

        this.getInfo();
        this.$fetch('/index/info').then(res => {
            this.info = res.data;
        })
    },
    methods:{
       // 获取初始化数据
       getInfo(){
        this.$fetch('Content/getShow').then(res => {
            if(res.code == 200){
                this.content = res.data.info;
            }
        })
      },
       // 顶部
       gotoT(){
          this.$refs.pageCon.scrollTop = 0;
       }
    }
}
</script>
<style scoped>
.yearShowPage{
    padding: 73px 410px;
    height: 80vh;
    overflow-y: auto;
    font-family: Microsoft YaHei;
    box-sizing: border-box;
}
.footerCon{
    width: 100%;
    height: 42px;
   background: rgba(245, 245, 245, 1);
    position: absolute;
    bottom: 0%;
    font-size: 14px;
    font-weight: bold;
    color: #3D3D3B;
    display: flex;
    justify-content: center;
}
.footerCon>div{
    display: flex;
    align-items: center;
}
.address{
    margin-right: 100px;
}
.address img{
    width: 20px;
    height: 22px;
    margin-right: 10px;
}
.email img{
    width: 19px;
    height: 14px;
    margin-right: 10px;
}
</style>


// WEBPACK FOOTER //
// src/pages/newPage/yearShow.vue